module.exports = {"520382001":"盐津街道","520382002":"中枢街道","520382003":"苍龙街道","520382004":"坛厂街道","520382005":"鲁班街道","520382102":"长岗镇","520382104":"五马镇","520382105":"茅坝镇","520382106":"九仓镇","520382107":"喜头镇","520382108":"大坝镇","520382109":"三合镇","520382110":"合马镇","520382112":"火石镇","520382113":"学孔镇","520382114":"龙井镇","520382115":"美酒河镇","520382116":"高大坪镇","520382117":"茅台镇","520382201":"后山苗族布依族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520382.json
// module id = 2476
// module chunks = 0